import { render, staticRenderFns } from "./Promo2019_Perif.vue?vue&type=template&id=8ba2feca&scoped=true&"
import script from "./Promo2019_Perif.vue?vue&type=script&lang=js&"
export * from "./Promo2019_Perif.vue?vue&type=script&lang=js&"
import style0 from "./Promo2019_Perif.vue?vue&type=style&index=0&id=8ba2feca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba2feca",
  null
  
)

export default component.exports